import React, { Component, Fragment } from 'react'

import './Default.css'

/*eslint-disable */
import { connect } from 'react-redux'
import GlobalActions from 'store/redux/global'
import Router from 'router'
import { Helmet } from 'react-helmet'
import { translate } from 'react-i18next'
import { StatusBar, CurrentSelectionModal, Spinner, Modal, Button, Alert } from 'components'
/*eslint-enable */

@connect(state => ({
    isAuthenticated: state.auth.isAuthenticated,
    loading: state.global.loading,
    loadingOpacity: state.global.loadingOpacity,
    modalData: state.global.modalData,
    pageData: state.page,
    phase: state.phaseInfo.phase
}),
    {
        cleanModal: GlobalActions.cleanModal
    })
@translate()
export default class Default extends Component {
    componentWillMount() {
        this.updateMetasArray(this.props.pageData.headData.metas)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.pageData !== this.props.pageData) {
            this.updateMetasArray(nextProps.pageData.headData.metas)
        }
    }
    updateMetasArray = (metasObject = {}) => {
        this.metas = Object.keys(metasObject).reduce((result, key) => [...result, { name: key, content: metasObject[key] }], [])
    }

    handleModalDismiss = () => {
        const { modalData: { callback } = {}, cleanModal } = this.props
        callback && callback()
        cleanModal()
    }
    handleModalActionAndDismiss = action => {
        this.handleModalDismiss()
        action && action()
    }

    renderMeta({ name, content }) {
        return <meta name={name} content={content} key={name} />
    }
    renderModal = () => {
        const { modalData: { type, title = null, text = null, actionBtns = [] } = {} } = this.props
        return (
            <Modal className={type} isOpen={title !== null || text !== null} title={title} text={text} onDismiss={this.handleModalDismiss}>
                <div className={['modal-actions flex', { 'row-stretch': actionBtns.length <= 2, 'col-stretch': actionBtns.length > 2 }]}>
                    {actionBtns.map(({ text: btnText, action }, i) =>
                        <Button key={i} color="primary" outline={i < actionBtns.length - 1} onClick={() => this.handleModalActionAndDismiss(action)}>{btnText}</Button>
                    )}
                </div>
            </Modal>
        )
    }
    render() {
        const { loading, loadingOpacity, pageData, t } = this.props
        const { title } = pageData.headData
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    {title && (
                        <title>
                            {title} - {t('meta.title')}
                        </title>
                    )}
                    {this.metas.map(this.renderMeta)}
                </Helmet>
                <Spinner active={loading} opacity={loadingOpacity} />
                <div className="AppContentWrapper">
                    <StatusBar />
                    <CurrentSelectionModal />
                    <div className="AppContent">
                        <Router />
                    </div>
                </div>
                {this.renderModal()}
                <Alert />
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// src/layout/Default.js